import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import useCountUp from "../hooks/useCountUp";

function HomeHeroSection({
    hero,
    escudo,
    isLoading,
    cantidadPartidosTotal,
    cantidadPartidosGanados,
    cantidadPartidosPerdidos,
    getPercentage,
}) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!isLoading) return;
        const t = setTimeout(() => setVisible(true), 50);
        return () => clearTimeout(t);
    }, [isLoading]);

    const countTotal = useCountUp(cantidadPartidosTotal, 2200, isLoading);
    const countGanados = useCountUp(cantidadPartidosGanados, 2200, isLoading);
    const countPerdidos = useCountUp(cantidadPartidosPerdidos, 2200, isLoading);

    return (
        <header className="relative h-screen flex items-center justify-center overflow-hidden pt-16 pb-28 sm:pb-36">
            <img
                src={hero}
                alt=""
                className="absolute inset-0 w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/80"></div>
            {isLoading ?
                <>
                    <div
                        className="relative z-10 text-center px-4 w-full max-w-4xl transition-all duration-700 ease-out"
                        style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(2rem)' }}
                    >
                            <div className="flex justify-center gap-1.5 mb-4">
                                <span className="h-1 w-8 bg-green-400"></span>
                                <span className="h-1 w-4 bg-white"></span>
                                <span className="h-1 w-8 bg-red-400"></span>
                            </div>
                        <h1 className="uppercase leading-[0.78] mb-6 drop-shadow-2xl font-bold">
                            <span className="block text-4xl cellphone:text-6xl md:text-9xl text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.8)] md:[-webkit-text-stroke:2px_rgba(255,255,255,0.8)]">AGUADA</span>
                            <span className="block text-4xl cellphone:text-6xl md:text-9xl text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.8)] md:[-webkit-text-stroke:2px_rgba(255,255,255,0.8)]">STATS</span>
                        </h1>
                        <div className="mt-6 flex items-center justify-center gap-3 text-sm cellphone:text-base md:text-lg text-slate-200">
                            <span className="h-px w-7 cellphone:w-12 bg-green-400"></span>
                            <p className="max-w-md font-medium">Archivo estadístico de jugadores, técnicos, récords y torneos</p>
                            <span className="h-px w-7 cellphone:w-12 bg-red-400"></span>
                        </div>
                    </div>

                    <div
                        className="absolute bottom-0 left-0 w-full py-4 sm:py-8 rounded-none border border-white/20 border-t-0 border-x-0 backdrop-blur-lg bg-white/5 shadow-[inset_0_1px_1px_rgba(255,255,255,0.1),0_10px_30px_-5px_rgba(0,0,0,0.4)] transition-all duration-700 ease-out"
                        style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(1rem)', transitionDelay: visible ? '150ms' : '0ms' }}
                    >
                        <div className="max-w-7xl mx-auto px-2 sm:px-4 grid grid-cols-3 divide-x divide-white/10">
                            <div className="text-center px-1">
                                <div className="text-2xl cellphone:text-4xl md:text-5xl text-white font-bold">
                                    {countTotal}
                                </div>
                                <div className="text-slate-400 uppercase tracking-widest text-[10px] cellphone:text-xs font-semibold mt-1">Partidos</div>
                            </div>
                            <div className="text-center px-1">
                                <div className="flex flex-col cellphone:flex-row items-center justify-center cellphone:gap-2">
                                    <span className="text-2xl cellphone:text-4xl md:text-5xl text-white font-bold">
                                        {countGanados}
                                    </span>
                                    <span className="text-green-400 text-[10px] cellphone:text-sm font-medium">
                                        ({getPercentage(countGanados, countTotal)}%)
                                    </span>
                                </div>
                                <div className="text-slate-400 uppercase tracking-widest text-[10px] cellphone:text-xs font-semibold mt-1">Ganados</div>
                            </div>
                            <div className="text-center px-1">
                                <div className="flex flex-col cellphone:flex-row items-center justify-center cellphone:gap-2">
                                    <span className="text-2xl cellphone:text-4xl md:text-5xl text-white font-bold">
                                        {countPerdidos}
                                    </span>
                                    <span className="text-red-400 text-[10px] cellphone:text-sm font-medium">
                                        ({getPercentage(countPerdidos, countTotal)}%)
                                    </span>
                                </div>
                                <div className="text-slate-400 uppercase tracking-widest text-[10px] cellphone:text-xs font-semibold mt-1">Perdidos</div>
                            </div>
                        </div>
                    </div>
                </>
                :
                createPortal(
                    <div className="fixed inset-0 z-[60] min-h-screen w-screen backdrop-blur-xl bg-white/20 p-10 rounded-none flex flex-col justify-center items-center">
                        <img src={escudo} alt="" className='loadingHome' />
                        <p className="text-center text-white text-lg font-semibold mt-6">
                            CARGANDO DATOS<span className="loadingDots"></span>
                        </p>
                    </div>,
                    document.body
                )
            }
        </header>
    );
}

export default HomeHeroSection;
